import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "materialIcon"
})
export class MaterialIconPipe implements PipeTransform {
    transform(file: string): string {
        const extension = file.split(".").pop();

        switch (extension?.toLowerCase()) {
            case "jpg":
            case "gif":
            case "jpeg":
            case "png":
            case "bmp":
                return "insert_photo";
            case "mp3":
            case "wav":
                return "audiotrack";
            case "mp4":
            case "mkv":
            case "avi":
            case "webm":
                return "music_video";
            case "pdf":
                return "picture_as_pdf";
            default:
                return "insert_drive_file";
        }
    }
}
